import { Validator } from "../Validator";

export class Empty extends Validator {
    public validate(): boolean {
        return true;
    }
}
